import { useGetMeQuery, useGetMyStatsQuery } from '@/services/qgammonApi';
import { AltriModiDiGiocare } from '@/components/backgammon/AltriModiDiGiocare';
import { RankedQueueEntry } from '@/components/backgammon/RankedQueueEntry';

/**
 * La PRIMA scheda del backgammon — chiave `'ranked'`, etichetta «Gioca» dal 01/10 (Luca, I-282: «Sezione
 * ranked la chiami sezione Play e la sezione play di oggi la nascondi perché le funzionalità sono già
 * state raccolte nella nuova ranked»). ⚠️ La CHIAVE resta `'ranked'`: le chiavi delle schede della Hub
 * sono condivise fra i giochi (`HubSections`, `AzionePersistente`), e cambiarla qui toccherebbe anche
 * loro. Reference approvata il 30/09, «Anello che respira» (Luca, I-277, scelta **L-2606 (a)**; KB
 * `services/qlash-telegram-app/ui/2026-09-30-backgammon-ranked-anello.md`, contratto di fronte
 * `fronti/tma/ranked-bg.md`), con le correzioni di I-282:
 *  - la card con l'ANELLO, che E' il bottone della classificata (con orologio, l'unica), senza piu'
 *    l'etichetta «Ranked» in testa; le ricerche, di tutte e due le code, DENTRO l'anello —
 *    `RankedQueueEntry`;
 *  - sotto la card, le TESSERE due per riga: coda senza orologio e fuori classifica (a serratura
 *    accesa), bot, amico, codice — `AltriModiDiGiocare`, senza piu' il titolo «Altri modi di giocare»;
 *  - ⛔ **niente piu' «Il tuo incontro»** in fondo: c'era per Luca, L-2637 (a) del 01/10 («in fondo alla nuova
 *    Gioca solo «Il tuo incontro», quando c'è, senza lista tornei»), e l'ha tolto Luca con I-334 C il 04/10 («alla fine
 *    delle opzioni gioco vedo: "Il tuo incontro · Round 1 · Tavolo 1 · martha", quelle info si posso rimuovere»). Era una
 *    riga senza niente da premere: l'incontro si raggiunge dalla barra delle azioni, dalla scheda «Tornei» e da «Le mie
 *    iscrizioni». ⛔ E nessuna scheda di torneo qui (Luca, 24/09: «niente lista tornei in classificata»);
 *  - ⛔ **niente piu' «Ultimi 5 risultati»** (I-277: «abbiamo gia' la sezione dedicata»): lo storico sta
 *    nella scheda «Partite» (di tma-orcr, I-276), e il modulo che li calcolava (in `lib/qgammon/`),
 *    rimasto senza chiamanti, e' stato tolto d'intesa con lei (19:45:49Z). ⚠️ Il suo nome non si scrive
 *    qui: il criterio C4 del fronte lo cerca con un grep su `src`, e deve dare zero.
 *
 * ⚠️ L'ELO viene dalle statistiche, o dall'identita' se quelle non ci sono: e' lo stesso campo
 * (`User.elo`). La POSIZIONE invece esiste solo se `/me/stats` ha risposto: senza, non si scrive.
 * ⚠️ Le code funzionano anche se le statistiche non rispondono: entrare in coda non dipende da
 * nessuna lettura, e l'anello resta un bottone anche senza la riga dell'ELO.
 */
export function QgammonRankedPanel() {
  const { data: me } = useGetMeQuery();
  const stats = useGetMyStatsQuery(undefined, { refetchOnMountOrArgChange: true });

  const elo = stats.data?.elo ?? me?.user.elo ?? null;
  const rank = stats.data?.rank ?? null;

  return (
    // 🔴 NON SCORRE (I-334 D): il pannello e' un contenitore e anello e tessere si misurano sulla sua altezza
    // (`.gioca-bg*` in globals.css). `overflow-y-auto` resta SEMPRE: con la regola lo scroll e' 0, e se il contenuto
    // non ci sta (testo ingrandito, WebView senza container query) si scorre invece di tagliare.
    <div className="gioca-bg min-h-0 flex-1 overflow-y-auto overscroll-contain">
      <div className="gioca-bg-colonna">
        <RankedQueueEntry
          elo={elo}
          rank={rank}
          altri={({ inerte, libera }) => <AltriModiDiGiocare inerte={inerte} libera={libera} />}
        />
      </div>
    </div>
  );
}
